import React, { useEffect, useMemo } from 'react';
import PageContainer from '../PageContainer';
import { useKennoTenant } from '../../context/kennoTenantContext';
import Card from '../../components/common/Card';
import { AnchorButton, Body2, H1 } from '../../components/common';
import PaddedContent from '../../components/housing/PaddedContent';
import { useMessageGetter } from 'react-message-context';
import { PdfIcon } from '../../assets';
import { LOAD_STATES } from '../../context/common';
import Loader from '../../components/basic/Loader';
import { RouteComponentProps } from 'react-router';
import { CardContainer } from '../../components/common/CardContainer';
import { loadDocuments } from '../../context/kennoTenantActions';

const GuidesAndDocumentsPage = ({ history }: RouteComponentProps) => {
  const t = useMessageGetter('myBuilding.documents');
  const [{ documents }, dispatch] = useKennoTenant();

  useEffect(() => {
    loadDocuments(dispatch);
  }, [dispatch]);

  const documentsLoading = documents.loadState === LOAD_STATES.BUSY;

  const documentLinks = useMemo(() => {
    return [
      documents.data?.costCenterLinks ?? [],
      documents.data?.apartmentLinks ?? [],
      documents.data?.buildingLinks ?? [],
    ]
      .flat()
      .filter((d) => d.Folder1.toLowerCase() === 'kodin kansio');
  }, [documents]);

  const hasDocuments = documentLinks.length;

  return (
    <PageContainer history={history}>
      <PaddedContent>
        <H1>{t('title')}</H1>
        <Body2>{t('description')}</Body2>
        <CardContainer>
          {documentsLoading && <Loader />}
          {hasDocuments ? (
            documentLinks?.map((document, i) => (
              <Card
                title={document.name}
                key={i}
                Icon={PdfIcon}
                secondaryButton={
                  <AnchorButton primary size="small" href={document.href}>
                    {t('downloadPdf')}
                  </AnchorButton>
                }
                contentPadding={'6px'}
              ></Card>
            ))
          ) : (
            <Body2>{t('noDocuments')}</Body2>
          )}
        </CardContainer>
      </PaddedContent>
    </PageContainer>
  );
};

export default GuidesAndDocumentsPage;
